/* eslint-disable @typescript-eslint/naming-convention */
export const COLORS = {
  BLACK: '#000000',
  BLUE: {
    50: '#EAEDFD',
    100: '#CAD3FD',
    200: '#A5B2FD',
    300: '#8497FE',
    400: '#3354FF',
    500: '#2842C8',
    600: '#2D3F9A',
    700: '#2A356F',
    800: '#282D48',
    900: '#25262D',
  },
  CATEGORY_COLOR: {
    aquaBlue: '#3FD2E4',
    black: '#000000',
    blue: '#4A70FF',
    blueViolet: '#7326D3',
    green: '#09AB6E',
    hotPink: '#FF48AF',
    lime: '#80CE61',
    mentis: '#80CE61',
    mint: '#0FB5AE',
    oceanBlue: '#4046CA',
    orange: '#F68511',
    pink: '#DE3D82',
    purple: '#8C2981',
    redOrange: '#ED5616',
    skyBlue: '#13A1F6',
    violet: '#57157E',
    white: '#FFFFFF',
    yellow: '#F5D633',
  },
  GRAY: {
    50: '#FAFAFB',
    75: '#F5F5F7',
    100: '#EDEEF1',
    200: '#E5E6E9',
    300: '#D4D5D8',
    400: '#C5C6C9',
    500: '#B0B1B4',
    600: '#7F8083',
    700: '#656669',
    800: '#4B4C4F',
    900: '#2F3033',
    1000: '#1A1B1D',
  },
  GREEN: {
    50: '#DEF2E6',
    100: '#B5E3C9',
    200: '#88D2A8',
    300: '#5FC48B',
    400: '#1FAD5C',
    500: '#1E8148',
    600: '#21693F',
    700: '#214F35',
    800: '#21362A',
    900: '#242926',
  },
  RED: {
    100: '#F3B9BC',
    200: '#EE9196',
    300: '#E8636B',
    400: '#E0242E',
    50: '#FAE6E7',
    500: '#AA2229',
    600: '#852329',
    700: '#652528',
    800: '#422426',
    900: '#2A2323',
  },
  TRANSPARENCY: {
    100: 'rgba(47, 48, 51, 0.1)',
    200: 'rgba(47, 48, 51, 0.2)',
    300: 'rgba(47, 48, 51, 0.3)',
    400: 'rgba(47, 48, 51, 0.4)',
    500: 'rgba(47, 48, 51, 0.5)',
    600: 'rgba(47, 48, 51, 0.6)',
    700: 'rgba(47, 48, 51, 0.7)',
    800: 'rgba(47, 48, 51, 0.8)',
    900: 'rgba(47, 48, 51, 0.9)',
  },

  WHITE: '#FFFFFF',

  YELLOW: {
    50: '#FBF7DF',
    100: '#FAECAE',
    200: '#F8E37C',
    300: '#F7D94A',
    400: '#F5CB00',
    500: '#B49609',
    600: '#8E7810',
    700: '#6C5D19',
    800: '#47401F',
    900: '#2B2922',
  },
} as const;

// ? 25.07.31 콘솔 파운데이션에 정의한 값으로 재정의
export const FONT_WEIGHT = {
  EXTRA_LIGHT: 100,
  LIGHT: 200,
  REGULAR: 300,
  MEDIUM: 400,
  SEMI_BOLD: 500,
  BOLD: 600,
  EXTRA_BOLD: 700,
};

export const FONT_SIZE = {
  10: '0.625rem',
  11: '0.6875rem', // 50
  12: '0.75rem', // 75
  13: '0.8125rem',
  14: '0.875rem', // 100
  16: '1rem', // 200
  18: '1.125rem', // 300
  20: '1.25rem',
  24: '1.5rem', // 400
  28: '1.75rem',
  32: '2rem', // 500
  36: '2.25rem',
  40: '2.5rem',
  42: '2.625rem', // 600
  48: '3rem', // 700
  54: '3.375rem',
  64: '4rem', // 800
} as const;
